export enum ResearchType {
    Document = 'Document',
    VideoUrl = 'VideoUrl'
}

export const RESEARCH_TYPES: { label: string; value: string }[] = [
    { label: 'Document Upload', value: ResearchType.Document },
    { label: 'Video URL', value: ResearchType.VideoUrl },
];
